import React, { useState } from 'react';
import {
  Card,
  Row,
  Col,
  Button,
  Badge,
  Form,
  InputGroup,
  Modal,
  Toast,
  ToastContainer,
  Spinner,
  Alert,
} from 'react-bootstrap';
import {
 
  CheckCircle,
  Search,
  QrCode,
  Shield,
  People,
  InfoCircle,
  
  Person,

  Check,
  Prescription,
  XCircle,
  
  Clock,
} from 'react-bootstrap-icons';
import { useAuth } from '../../contexts/AuthContext';

// Données fictives enrichies avec plus d'informations sur les médicaments
const mockPrescriptions = [
  { 
    id: 'P001', date: '2025-03-12', patientName: 'Jean Dupont', patientId: 'CNAMGS-123456',
    medicines: [
      { name: 'Paracétamol 500mg', dosage: '2x/jour', quantity: 20 },
      { name: 'Vitamine C 1000mg', dosage: '1x/jour', quantity: 30 }
    ],
    doctor: 'Dr. Nzogho', status: 'pending'
  },
  { 
    id: 'P002', date: '2025-03-10', patientName: 'Marie Nzogho', patientId: 'CNAMGS-789012',
    medicines: [
      { name: 'Cetirizine 10mg', dosage: '1x/jour', quantity: 10 }
    ],
    doctor: 'Dr. Ondo', status: 'pending'
  },
  { 
    id: 'P003', date: '2025-03-08', patientName: 'Pierre Mba', patientId: 'CNAMGS-345678',
    medicines: [
      { name: 'Amoxicilline 500mg', dosage: '2x/jour', quantity: 15 }
    ],
    doctor: 'Dr. Nzogho', status: 'pending'
  },
  { 
    id: 'P004', date: '2025-03-05', patientName: 'Sophie Nguema', patientId: 'CNAMGS-111222',
    medicines: [
      { name: 'Loratadine 10mg', dosage: '1x/jour', quantity: 10 }
    ],
    doctor: 'Dr. Ondo', status: 'pending'
  },
];

const DispenseForm = () => {
  const { user } = useAuth();
  const [prescriptions, setPrescriptions] = useState(mockPrescriptions);
  const [prescriptionId, setPrescriptionId] = useState('');
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [medicinesAvailability, setMedicinesAvailability] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState('');

  const showToast = (message, variant = 'success') => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast(prev => ({ ...prev, show: false })), 4000);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const handleCheck = () => {
    if (!prescriptionId.trim()) {
      setError('Veuillez saisir un numéro d’ordonnance');
      return;
    }

    setChecking(true);
    setError('');
    setTimeout(() => {
      const found = prescriptions.find(p => p.id === prescriptionId.trim());
      if (found) {
        if (found.status === 'pending') {
          setSelectedPrescription(found);
          // Initialiser la disponibilité des médicaments : tous disponibles par défaut
          setMedicinesAvailability(found.medicines.map(() => true));
          setError('');
        } else {
          setSelectedPrescription(null);
          setError('Cette ordonnance a déjà été délivrée.');
        }
      } else {
        setSelectedPrescription(null);
        setError('Ordonnance non trouvée. Vérifiez le numéro.');
      }
      setChecking(false);
    }, 500);
  };

  const toggleMedicineAvailability = (index) => {
    setMedicinesAvailability(prev => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const handleDispense = () => {
    if (selectedPrescription) {
      setShowConfirmModal(true);
    }
  };

  const confirmDispense = () => {
    setLoading(true);
    setTimeout(() => {
      // Mettre à jour le statut localement
      setPrescriptions(prev =>
        prev.map(p =>
          p.id === selectedPrescription.id ? { ...p, status: 'dispensed' } : p
        )
      );
      // Simuler l'envoi de la disponibilité (on pourrait enregistrer les choix)
      const availableCount = medicinesAvailability.filter(v => v).length;
      showToast(
        `Ordonnance ${selectedPrescription.id} délivrée avec succès (${availableCount}/${medicinesAvailability.length} médicaments disponibles)`,
        'success'
      );
      setPrescriptionId('');
      setSelectedPrescription(null);
      setMedicinesAvailability([]);
      setShowConfirmModal(false);
      setLoading(false);
    }, 800);
  };

  const availableCount = medicinesAvailability.filter(v => v).length;
  const totalMedicines = medicinesAvailability.length;
  const availabilityRate = totalMedicines > 0 ? (availableCount / totalMedicines) * 100 : 0;

  return (
    <div className="" style={{ fontFamily: "'Inter', sans-serif" }}>
      <ToastContainer className="p-3" style={{ zIndex: 9999, position: 'fixed', top: '20px', right: '20px' }}>
        <Toast show={toast.show} onClose={() => setToast(prev => ({ ...prev, show: false }))} bg={toast.variant} delay={4000} autohide>
          <Toast.Header closeButton={false}>
            <strong className="me-auto">
              {toast.variant === 'success' ? 'Succès' : toast.variant === 'danger' ? 'Erreur' : 'Information'}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="container-fluid">
        {/* En-tête */}
        <div className="mb-4">
          <h4 className="main-title mb-0 d-flex align-items-center gap-2">
            <div className="bg-success bg-opacity-10 rounded-circle p-2">
              <Prescription size={24} className="text-success" />
            </div>
            Délivrance d'ordonnance
          </h4>
          <p className="text-muted mb-0 mt-1">
            Saisissez le numéro de l'ordonnance, vérifiez la disponibilité des médicaments et délivrez
          </p>
        </div>

        {/* Zone de saisie du code */}
        <Card className="border-0 shadow-sm mb-4 bg-white" style={{ borderRadius: '20px' }}>
          <Card.Body className="p-4">
            <InputGroup>
              <InputGroup.Text className="bg-light border-0 rounded-start-pill">
                <QrCode size={18} className="text-muted" />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Numéro d'ordonnance (ex: P001)"
                value={prescriptionId}
                onChange={(e) => setPrescriptionId(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleCheck()}
                className="border-0 bg-light"
              />
              <Button
                variant="primary"
                onClick={handleCheck}
                disabled={checking}
                className="rounded-pill px-4"
              >
                {checking ? <Spinner size="sm" className="me-1" /> : <Search size={16} className="me-1" />}
                {checking ? 'Vérification...' : 'Vérifier'}
              </Button>
            </InputGroup>
            {error && (
              <Alert variant="danger" className="mt-3 mb-0 small">
                <InfoCircle size={14} className="me-1" /> {error}
              </Alert>
            )}
          </Card.Body>
        </Card>

        {/* Affichage de l'ordonnance */}
        {selectedPrescription && (
          <Card className="border-0 shadow-lg mb-4" style={{ borderRadius: '24px', overflow: 'hidden' }}>
            {/* En-tête */}
            <div style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', padding: '1.5rem' }}>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="bg-white bg-opacity-20 rounded-circle p-2">
                    <Prescription size={28} className="text-primary" />
                  </div>
                  <div>
                    <h5 className="text-white mb-0">Ordonnance n° {selectedPrescription.id}</h5>
                    <p className="text-white-50 mb-0 small">Générée le {formatDate(selectedPrescription.date)}</p>
                  </div>
                </div>
                <Badge bg="warning" className="rounded-pill px-3 py-2">
                  <Clock size={12} className="me-1" /> En attente de délivrance
                </Badge>
              </div>
            </div>

            <Card.Body className="p-4">
              <Row className="g-4 mb-4">
                {/* Informations patient */}
                <Col md={6}>
                  <div className="bg-light rounded-3 p-3 h-100">
                    <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2">
                      <Person size={16} className="text-primary" />
                      Informations patient
                    </h6>
                    <div className="mb-2">
                      <small className="text-muted d-block">Nom complet</small>
                      <strong>{selectedPrescription.patientName}</strong>
                    </div>
                    <div className="mb-2">
                      <small className="text-muted d-block">Numéro d'assuré</small>
                      <strong>{selectedPrescription.patientId}</strong>
                    </div>
                  </div>
                </Col>
                {/* Informations médecin */}
                <Col md={6}>
                  <div className="bg-light rounded-3 p-3 h-100">
                    <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2">
                      <Shield size={16} className="text-primary" />
                      Médecin prescripteur
                    </h6>
                    <div className="mb-2">
                      <small className="text-muted d-block">Nom</small>
                      <strong>{selectedPrescription.doctor}</strong>
                    </div>
                    <div className="mb-2">
                      <small className="text-muted d-block">Date de prescription</small>
                      <strong>{formatDate(selectedPrescription.date)}</strong>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Liste des médicaments avec cases à cocher */}
              <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2">
                <Prescription size={18} className="text-success" />
                Médicaments prescrits
              </h6>
              <div className="bg-light rounded-3 p-3 mb-4">
                {selectedPrescription.medicines.map((med, idx) => (
                  <div key={idx} className="d-flex align-items-center justify-content-between py-2 border-bottom border-light">
                    <div className="d-flex align-items-center gap-3">
                      <Form.Check
                        type="checkbox"
                        id={`med-${idx}`}
                        checked={medicinesAvailability[idx]}
                        onChange={() => toggleMedicineAvailability(idx)}
                        label=""
                        className="me-2"
                      />
                      <div>
                        <strong>{med.name}</strong>
                        <div className="small text-muted">{med.dosage} · Quantité : {med.quantity}</div>
                      </div>
                    </div>
                    <div>
                      {medicinesAvailability[idx] ? (
                        <Badge bg="success" className="rounded-pill">
                          <CheckCircle size={10} className="me-1" /> Disponible
                        </Badge>
                      ) : (
                        <Badge bg="danger" className="rounded-pill">
                          <XCircle size={10} className="me-1" /> Indisponible
                        </Badge>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Indicateur de disponibilité globale */}
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="small fw-semibold">Disponibilité en stock</span>
                  <span className="small fw-bold">{availableCount} / {totalMedicines} médicaments</span>
                </div>
                <div className="progress" style={{ height: '8px' }}>
                  <div
                    className="progress-bar bg-success"
                    style={{ width: `${availabilityRate}%` }}
                  ></div>
                </div>
                {availableCount < totalMedicines && (
                  <div className="mt-2 text-warning small">
                    <InfoCircle size={12} className="me-1" />
                    Certains médicaments ne sont pas disponibles. La délivrance partielle est possible.
                  </div>
                )}
              </div>

              {/* Bouton de délivrance */}
              <div className="d-flex justify-content-end">
                <Button
                  variant="success"
                  size="lg"
                  className="rounded-pill px-5"
                  onClick={handleDispense}
                  disabled={availableCount === 0}
                >
                  <CheckCircle size={20} className="me-2" />
                  Délivrer {availableCount < totalMedicines ? 'partiellement' : ''}
                </Button>
              </div>
            </Card.Body>
          </Card>
        )}

        {/* Message d'information si aucune ordonnance chargée */}
        {!selectedPrescription && !error && (
          <Alert variant="info" className="border-0 rounded-3 shadow-sm" style={{ background: 'linear-gradient(135deg, #e8f4fd 0%, #d9eaff 100%)' }}>
            <div className="d-flex align-items-center gap-3">
              <InfoCircle size={24} className="text-info" />
              <div>
                <strong className="d-block mb-1">Aucune ordonnance chargée</strong>
                <span className="small">
                  Saisissez un numéro d’ordonnance ci-dessus pour afficher les détails et vérifier la disponibilité des médicaments.
                </span>
              </div>
            </div>
          </Alert>
        )}

        {/* Modal de confirmation */}
        <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title className="d-flex align-items-center gap-2">
              <CheckCircle size={20} />
              Confirmer la délivrance
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedPrescription && (
              <>
                <div className="mb-3 p-3 rounded-3" style={{ background: '#e8f5e9', borderLeft: '4px solid #10b981' }}>
                  <div className="d-flex align-items-center gap-2">
                    <People size={18} className="text-success" />
                    <strong>Patient :</strong> {selectedPrescription.patientName}
                    <span className="text-muted">({selectedPrescription.patientId})</span>
                  </div>
                </div>
                <Row>
                  <Col md={12}>
                    <div className="mb-3">
                      <small className="text-muted d-block">Médicaments à délivrer</small>
                      <ul className="list-unstyled mt-2">
                        {selectedPrescription.medicines.map((med, idx) => (
                          <li key={idx} className="d-flex align-items-center gap-2 mb-1">
                            {medicinesAvailability[idx] ? (
                              <CheckCircle size={14} className="text-success" />
                            ) : (
                              <XCircle size={14} className="text-danger" />
                            )}
                            <span className={!medicinesAvailability[idx] ? 'text-muted' : ''}>
                              {med.name} - {med.dosage}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <Alert variant="info" className="mt-2">
                      <InfoCircle size={14} className="me-1" />
                      La demande de remboursement ne concernera que les médicaments délivrés.
                    </Alert>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowConfirmModal(false)} className="rounded-pill">
              Annuler
            </Button>
            <Button variant="success" onClick={confirmDispense} disabled={loading} className="rounded-pill px-4">
              {loading ? <Spinner size="sm" className="me-1" /> : <Check size={16} className="me-1" />}
              {loading ? 'Délivrance...' : 'Confirmer'}
            </Button>
          </Modal.Footer>
        </Modal>

        <style>{`
          .card {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .card:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 20px -8px rgba(0, 0, 0, 0.15) !important;
          }
          .form-check-input:checked {
            background-color: #10b981;
            border-color: #10b981;
          }
          .progress {
            background-color: #e9ecef;
            border-radius: 4px;
          }
        `}</style>
      </div>
    </div>
  );
};

export default DispenseForm;